import { Separator } from '@givebutter/primitives/separator';
import Content from 'assets/js/components/Content';
import { EngageMetricsCards } from 'assets/js/pages/engage/metrics/EngageMetricsCards';
import { EngageMetricsDetails } from 'assets/js/pages/engage/metrics/EngageMetricsDetails';
import { EngageMetricsEmailPreview } from 'assets/js/pages/engage/metrics/EngageMetricsEmailPreview';
import { EngageMetricsHeader } from 'assets/js/pages/engage/metrics/EngageMetricsHeader';
import { EngageMetricsRecipientsTable } from 'assets/js/pages/engage/metrics/EngageMetricsRecipientsTable';

const MetricsIndex = () => {
    return (
        <Content>
            <div className="flex flex-col gap-y-4">
                <EngageMetricsHeader />
                <Separator />
                <div className="flex h-full flex-col items-stretch gap-4 md:flex-row">
                    <div className="flex-1">
                        <EngageMetricsDetails />
                    </div>
                    <div className="relative flex-1">
                        <EngageMetricsEmailPreview />
                    </div>
                </div>
                <EngageMetricsCards />
                <EngageMetricsRecipientsTable />
            </div>
        </Content>
    );
};

export { MetricsIndex };
